module.exports = __webpack_public_path__ + "static/media/ana_lucia_dos_santos.66ae157d.jpg";